/* Handle some navigation related stuff like adding dropdown arrows to navigation item parents with submenus */

class ProfetNavigation {
	constructor() {
		this.headerDesktop = document.querySelector('.globalamalen-header-desktop');
		this.headerMobile = document.querySelector('.globalamalen-header-mobile');
		this.closeSearchButton = document.querySelector('.close-search');
		this.searchDesktopWrapper = document.querySelector('.search-desktop-wrapper');
		this.menuMoreButton = document.querySelector('.menu-item-more a');
		this.dropdownArrows = [];
	}
	init() {
		this.addDropdownArrows();
		this.handleClicks();
		this.setDesktopMoreMenuMaxWidth();
		this.setBodyPadding();
		window.addEventListener('resize', () => {
			this.setDesktopMoreMenuMaxWidth();
			this.setBodyPadding();
		});
		this.handleLeavePage();
		this.handleNavigationItemFocus();
	}
	handleLeavePage() {
		window.addEventListener('beforeunload', () => {
			if (this.headerDesktop) {
				this.headerDesktop.querySelector('.site-logo img').classList.add('logo-loading');
			}
			if (this.headerMobile) {
				this.headerMobile.querySelector('img.logo').classList.add('logo-loading');
			}
		});
	}
	setBodyPadding() {
		/* Set body padding so that the fixed menu doesn't overlap content on the page */
		var paddingToSet = 0;
		if (this.headerMobile) {
			if (this.headerMobile.offsetHeight > 0) {
				paddingToSet = this.headerMobile.offsetHeight;
			}
		}
		if (this.headerDesktop) {
			if (this.headerDesktop.offsetHeight > 0) {
				paddingToSet = this.headerDesktop.offsetHeight;
			}
		}
		document.querySelector('body').style.paddingTop = paddingToSet + 'px';
	}
	addDropdownArrows() {
		if (this.headerMobile) {
			var itemsWithSubmenus = this.headerMobile.querySelectorAll('.menu-item-has-children > a > .menu-item-label');
			for (var i = 0; i < itemsWithSubmenus.length; i++) {
				var dropdownArrow = document.createElement('span');
				dropdownArrow.classList.add('dropdown-arrow');
				itemsWithSubmenus[i].appendChild(dropdownArrow);
				this.dropdownArrows.push(dropdownArrow);
			}
			/*
            Set the active class on li elements with .current-menu-item or .current-menu-ancestor 
            classes so that the arrow next to them is pointing the right way.
            */
			var liElements = this.headerMobile.querySelectorAll('.menu-item-has-children');
			for (var i = 0; i < liElements.length; i++) {
				if (liElements[i].classList.contains('current-menu-item') || liElements[i].classList.contains('current-menu-ancestor')) {
					liElements[i].classList.add('active');
				}
			}

			/* Handle clicks on the dropdown arrow */
			for (let i in this.dropdownArrows) {
				this.dropdownArrows[i].addEventListener('click', (event) => {
					event.preventDefault();
					event.stopPropagation();
					var liElement = this.dropdownArrows[i].closest('li');
					liElement.classList.toggle('active');
				});
			}
		}
	}
	handleClicks() {
		/* Handle click on the More menu item */
		if (this.menuMoreButton) {
			this.menuMoreButton.addEventListener('click', (event) => {
				event.preventDefault();
				document.querySelector('body').classList.toggle('menu-more-open');
			});
		}
		if (this.closeSearchButton) {
			this.closeSearchButton.addEventListener('click', (event) => {
				event.preventDefault();
				this.searchDesktopWrapper.classList.remove('toggled');
			});
		}
	}
	/*
    Set the desktop More menu containers with to be equal to the desktop main navigation width.
    This is done to make everything align nicely.
    */
	setDesktopMoreMenuMaxWidth() {
		/* Set the desktop menu width as a css variable */
		if (!this.headerDesktop) {
			return;
		}
		var maxWidth = this.headerDesktop.querySelector('#menu-desktop-top-menu').offsetWidth;
		document.documentElement.style.setProperty('--more-menu-max-width', maxWidth + 'px');
	}

	/* When a user focuses on a navigation item, set the active class on the parent li element to make the submenu show. */
	handleNavigationItemFocus() {
		if (!this.headerDesktop) {
			return;
		}
		let submenuParents = this.headerDesktop.querySelectorAll('li.menu-item-has-children');
		let submenuItems = this.headerDesktop.querySelectorAll('.menu-item-has-children > a');
		let allLinkItems = document.querySelectorAll('#menu-desktop-top-menu > li > a');

		/* Remove a class from all link items so that no submenus are visible */
		allLinkItems.forEach((item) => {
			item.addEventListener('focus', (event) => {
				submenuParents.forEach((p) => {
					p.classList.remove('in-focus');
				});
			});
		});

		submenuItems.forEach((item) => {
			item.addEventListener('focus', (event) => {
				/* Add a class to this links parent item so that the submenu is visible */
				let parent = item.parentElement;
				parent.classList.add('in-focus');
			});
		});
	}
}
window.addEventListener('load', () => {
	window.profetNavigation = new ProfetNavigation();
	window.profetNavigation.init();
});
